/**
 * Checks if the given value is an array.
 * Alias for {@link Array.isArray}, but with better type inference.
 */
export const isArray = Array.isArray;
//# sourceMappingURL=isArray.js.map